/* Calmie native sections runtime.
   Replaces the parts of the Replo runtime the pages actually used:
   carousels, collapsibles, inline video controls and add-to-cart.
   No dependencies, no external CDN. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- carousel */
  function initCarousel(root) {
    if (root.dataset.calmieReady === '1') return;
    root.dataset.calmieReady = '1';

    var viewport = root.querySelector('.calmie-carousel__viewport');
    var track = root.querySelector('.calmie-carousel__track');
    var prev = root.querySelector('.calmie-carousel__arrow--prev');
    var next = root.querySelector('.calmie-carousel__arrow--next');
    var counter = root.querySelector('.calmie-carousel__count [data-current]');
    var dotsWrap = root.querySelector('[data-calmie-dots]');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var dots = [];

    function current() {
      var mid = viewport.scrollLeft + viewport.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function scrollToIndex(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      // centre the slide, but never scroll past the ends
      var target = s.offsetLeft - (viewport.clientWidth - s.offsetWidth) / 2;
      viewport.scrollTo({ left: target, behavior: 'smooth' });
    }

    function sync() {
      var i = current();
      if (counter) counter.textContent = String(i + 1);
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2;
    }

    // Dots are built from the slides so the markup never has to be kept in step.
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'calmie-carousel__dot';
        d.setAttribute('aria-label', 'Go to card ' + (i + 1));
        d.addEventListener('click', function () { scrollToIndex(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    if (prev) prev.addEventListener('click', function () { scrollToIndex(current() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(current() + 1); });

    var raf = null;
    viewport.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();

    // keyboard support on the viewport
    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollToIndex(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollToIndex(current() - 1); }
    });
  }

  /* ---------------------------------------------------------------- gallery */
  // Thumbnails drive the gallery carousel and track which slide is showing.
  function initGallery(root) {
    if (root.dataset.calmieGalleryReady === '1') return;
    root.dataset.calmieGalleryReady = '1';

    var carousel = root.querySelector('.calmie-carousel') || root;
    var viewport = carousel.querySelector('.calmie-carousel__viewport');
    var track = carousel.querySelector('.calmie-carousel__track');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.calmie-gallery__thumb'));
    if (!viewport || !track || !thumbs.length) return;
    var slides = Array.prototype.slice.call(track.children);

    function mark(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-goto'), 10) || 0;
        var s = slides[i];
        if (!s) return;
        viewport.scrollTo({ left: s.offsetLeft - (viewport.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
        mark(i);
      });
    });
    var raf = null;
    viewport.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var mid = viewport.scrollLeft + viewport.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        mark(best);
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------- collapsible */
  function initFaq(root) {
    if (root.dataset.calmieReady === '1') return;
    root.dataset.calmieReady = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.calmie-faq__q');
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.calmie-faq__item');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = item.querySelector('.calmie-faq__a');
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    });
  }

  /* ------------------------------------------------------------- video load */
  // Tiles ship with no src at all (see snippets/calmie-video.liquid), so a page
  // full of them costs zero video bytes. The URL is attached on the first real
  // play intent and never again.
  function attachSrc(video) {
    if (video.dataset.calmieSrcAttached === '1') return;
    var url = video.dataset.src;
    if (!url) return;
    video.dataset.calmieSrcAttached = '1';
    video.src = url;
    video.load();
  }

  // The poster is an <img> overlay, not the poster="" attribute, so we hide it
  // ourselves once there are real frames to show.
  function hidePoster(tile) {
    var img = tile.querySelector('.calmie-video__poster');
    if (img) img.classList.add('is-hidden');
  }

  /* -------------------------------------------------------------- video tile */
  function initVideo(tile) {
    if (tile.dataset.calmieReady === '1') return;
    tile.dataset.calmieReady = '1';
    var video = tile.querySelector('video');
    var play = tile.querySelector('.calmie-video__play');
    if (!video) return;

    function toggle() {
      if (video.paused) {
        attachSrc(video);
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    }
    video.addEventListener('play', function () { tile.classList.add('is-playing'); });
    video.addEventListener('playing', function () { hidePoster(tile); });
    video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { tile.classList.remove('is-playing'); });

    if (play) play.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    video.addEventListener('click', toggle);

    wireControls(tile, video);
  }

  // Sound and fullscreen. Autoplay tiles render these buttons too, so this has to
  // be reachable from initAutoVideo as well, not buried inside initVideo.
  function wireControls(tile, video) {
    var sound = tile.querySelector('[data-video-sound]');
    var full = tile.querySelector('[data-video-fullscreen]');
    if (sound) {
      sound.addEventListener('click', function (e) {
        e.stopPropagation();
        // An autoplaying tile has no src until it scrolls into view; unmuting
        // before then would otherwise silently do nothing.
        attachSrc(video);
        video.muted = !video.muted;
        if (!video.muted && video.paused) video.play().catch(function () {});
        sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        sound.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    }
    if (full) {
      full.addEventListener('click', function (e) {
        e.stopPropagation();
        attachSrc(video);
        var fn = video.requestFullscreen || video.webkitEnterFullscreen || video.webkitRequestFullscreen;
        if (fn) fn.call(video);
      });
    }
  }

  /* --------------------------------------------------------- autoplay video */
  // Muted, looping, and only while on screen, so we are not decoding video the
  // visitor cannot see.
  function initAutoVideo(tile) {
    if (tile.dataset.calmieAutoReady === '1') return;
    tile.dataset.calmieAutoReady = '1';
    var v = tile.querySelector('video');
    if (!v) return;
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.addEventListener('playing', function () { hidePoster(tile); });
    wireControls(tile, v);
    if (!('IntersectionObserver' in window)) { attachSrc(v); v.play().catch(function () {}); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          attachSrc(v);
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25, rootMargin: '200px 0px' });
    io.observe(tile);
  }

  /* ------------------------------------------------------------ add to cart */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Kaching Bundles owns the quantity picker. It renders no form of its own and
  // hooks nothing, so a custom button has to read the selected deal itself.
  // Without this every bundle adds a single unit while the page shows a 2 or 4
  // pack price. fetchDeals() maps the checked radio's deal-bar id to a quantity.
  var kachingDeals = null;
  function kachingQuantity() {
    var kb = document.querySelector('kaching-bundle');
    var api = window.kachingBundlesApi;
    if (!kb || !api || typeof api.fetchDeals !== 'function') return Promise.resolve(null);
    var sel = kb.querySelector('input[type="radio"]:checked');
    if (!sel || !sel.value) return Promise.resolve(null);
    var barId = sel.value;
    if (!kachingDeals) kachingDeals = api.fetchDeals();
    return Promise.resolve(kachingDeals)
      .then(function (list) {
        var qty = null;
        (list || []).forEach(function (deal) {
          (deal.dealBars || []).forEach(function (bar) {
            if (bar.id === barId && typeof bar.quantity === 'number') qty = bar.quantity;
          });
        });
        if (qty === null) console.warn('[calmie] no Kaching quantity for deal ' + barId);
        return qty;
      })
      .catch(function (err) {
        console.error('[calmie] Kaching deal lookup failed', err);
        kachingDeals = null;
        return null;
      });
  }

  // One product in the catalogue, so "buy" means make the cart exactly this.
  // cart/update.js sets the line quantity instead of adding to it, so coming
  // back from checkout and clicking again cannot silently double the order.
  function buyNow(id, qty) {
    var updates = {};
    updates[id] = qty;
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'cart/update ' + r.status);
        window.location.href = cartRoot() + 'checkout';
      });
    });
  }

  // Mirrors Dawn's product-form.js: sections come back in the same call, and
  // is-empty is cleared off the element afterwards. renderContents only clears it
  // from .drawer__inner, so without that a drawer that loaded with an empty cart
  // keeps its empty-cart layout and opens looking blank.
  function addAndOpenDrawer(btn, id, qty, original) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: qty }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'cart/add ' + r.status);
          return data;
        });
      })
      .then(function (data) {
        if (!cart || typeof cart.renderContents !== 'function' || !data.sections) {
          window.location.href = cartRoot() + 'cart';
          return;
        }
        if (!data.id && data.items && data.items[0]) data.id = data.items[0].id;
        cart.renderContents(data);
        cart.classList.remove('is-empty');
        // Let Dawn's own components and any cart apps know something changed.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'calmie-atc',
            productVariantId: String(id),
            cartData: data,
          });
        }
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  function initAtc(btn) {
    if (btn.dataset.calmieReady === '1') return;
    btn.dataset.calmieReady = '1';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var original = btn.textContent;
      var toCheckout = btn.getAttribute('data-atc-action') === 'checkout';
      btn.disabled = true;
      btn.textContent = toCheckout ? 'Taking you to checkout\u2026' : 'Adding\u2026';

      kachingQuantity()
        .then(function (kq) {
          var qty = kq || parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
          return toCheckout ? buyNow(id, qty) : addAndOpenDrawer(btn, id, qty, original);
        })
        .catch(function (err) {
          // Don't bounce the customer onward on failure: that looks like it worked.
          // Say so, and leave them where they are so they can retry.
          console.error('[calmie] add to cart', err);
          btn.disabled = false;
          btn.textContent = 'Could not add, please try again';
          setTimeout(function () { btn.textContent = original; }, 2500);
        });
    });
  }

  /* -------------------------------------------------------------------- boot */
  function boot(scope) {
    var el = scope || document;
    el.querySelectorAll('.calmie-carousel').forEach(initCarousel);
    el.querySelectorAll('[data-calmie-gallery]').forEach(function (c) {
      initGallery(c.closest('.calmie-buybox__gallery') || c);
    });
    el.querySelectorAll('.calmie-faq__list').forEach(initFaq);
    el.querySelectorAll('.calmie-video:not([data-autoplay])').forEach(initVideo);
    el.querySelectorAll('.calmie-video[data-autoplay]').forEach(initAutoVideo);
    el.querySelectorAll('.calmie-atc[data-variant-id]').forEach(initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Re-init after a theme-editor section reload.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
